import * as React from "react";

export const SIDEBAR_COOKIE_NAME = "sidebar:state";
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
export const SIDEBAR_WIDTH = "16rem"; // Increased from 12.8rem
export const SIDEBAR_WIDTH_MOBILE = "18rem"; // Increased from 14.4rem
export const SIDEBAR_WIDTH_ICON = "3.25rem"; // 52px - matched to w-9 + padding
export const SIDEBAR_KEYBOARD_SHORTCUT = "b";

export type SidebarContextType = {
  state: "expanded" | "collapsed";
  open: boolean;
  setOpen: (open: boolean) => void;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  isMobile: boolean;
  toggleSidebar: () => void;
};

export const SidebarContext = React.createContext<SidebarContextType | null>(null);

// Default fallback when no SidebarProvider is present (e.g. Desktop mode)
const SIDEBAR_FALLBACK: SidebarContextType = {
  state: "expanded",
  open: true,
  setOpen: () => {},
  openMobile: false,
  setOpenMobile: () => {},
  isMobile: false,
  toggleSidebar: () => {},
};

export function useSidebar() {
  const context = React.useContext(SidebarContext);
  // Graceful degradation: return fallback when outside SidebarProvider (Desktop mode)
  if (!context) {
    return SIDEBAR_FALLBACK;
  }

  return context;
}
